
import Vue from 'vue'
import Router from 'vue-router'
import auth from '../src/api/auth'
import Login from '../src/components/app/account/login.vue'
import Urunler from '../src/components/app/account/urunsatinal.vue'
import UrunSatis from './components/app/account/urunler.vue'

import Confirm from '../src/components/app/account/confirm.vue'
import helpers from "@/components/app/customcomp/helpers.js"
import customdialog from "@/components/app/customcomp/customdialog.vue"
import HataOdeme from "@/components/app/odeme/hata.vue"
import BasariliOdeme from "@/components/app/odeme/basarili.vue"
import OdemeSonuc from "@/components/app/odeme/sonuc.vue"
import ExcelSaticiAktarim from '@/components/app/coper/excelaktarim/saticiaktarim.vue'

import Anasirket from '../src/components/app/account/anasirket.vue'
import LoginUye from '../src/components/app/account/uye/index.vue'
import UyeDetay from '../src/components/app/account/uye/detay.vue'
import UyeYeni from '../src/components/app/account/uye/yeni.vue'
import UyeYetkiGrup from '../src/components/app/account/uye/yetkigrup.vue'
import UyeYetkiGrupList from '../src/components/app/account/uye/yetkigruplistesi.vue'
import DownloadPage from '../src/components/app/download/index.vue'
import CariPersonel from './components/app/cari/CustomerPersonelPage.vue'



import Home from '../src/components/app/home/index.vue'
import stripereturn from '../src/components/app/customcomp/stripereturn.vue'


import DestekVideos from '../src/components/app/destek/videos.vue'
import DestekYardim from '../src/components/app/destek/yardim.vue'


//Bilet Linkler
import BiletIndex from '../src/components/app/bilet/yeni.vue'
import Faturalibiletduzenle from '../src/components/app/bilet/faturalibiletduzenle.vue'

import BiletIade from '../src/components/app/bilet/biletiade.vue'
import BiletListe from '../src/components/app/bilet/index.vue'
import BiletAlisEntegre from '../src/components/app/bilet/indexIntegrate.vue'
import VoidListe from '../src/components/app/bilet/voidlistesi.vue'
import IadeListe from '../src/components/app/bilet/iadelistesi.vue'

import THYAktarim from '../src/components/app/bilet/aktarimbilet/thyaktarim.vue'
import THYAktarimXml from '../src/components/app/bilet/aktarimbilet/thyaktarimxml.vue'

import AmadeusAktarim from '../src/components/app/bilet/aktarimbilet/amadeusaktarim.vue'
import AmadeusAktarimFtp from '../src/components/app/bilet/aktarimbilet/amadeusaktarimftp.vue'

import JuniperAktarim from '../src/components/app/bilet/aktarimbilet/juniperaktarim.vue'

import baseaktar from '../src/components/app/bilet/aktarimbilet/baseaktarim.vue'
import pegasusaktar from '../src/components/app/bilet/aktarimbilet/pegasusaktarim.vue'
import pegasusonlineaktar from '../src/components/app/bilet/aktarimbilet/pegasusonlineaktarim.vue'

import ajetaktar from '../src/components/app/bilet/aktarimbilet/ajetaktarim.vue'
import ajetaktarimxml from '../src/components/app/bilet/aktarimbilet/ajetaktarimxml.vue'
import onuraktar from '../src/components/app/bilet/aktarimbilet/onurairaktarim.vue'
import iatiaktar from '../src/components/app/bilet/aktarimbilet/iatiaktarim.vue'
import sunexpressaktar from '../src/components/app/bilet/aktarimbilet/sunexpressaktarim.vue'
import freebirdaktar from '../src/components/app/bilet/aktarimbilet/freebirdaktarim.vue'
import galileoaktar from '../src/components/app/bilet/aktarimbilet/galileoaktarim.vue'
import sabreaktar from '../src/components/app/bilet/aktarimbilet/sabreaktarim.vue'
import bookingagoraaktar from '../src/components/app/bilet/aktarimbilet/bookingagoraaktarim.vue'
import lydiaaktar from '../src/components/app/bilet/aktarimbilet/lydiaaktarim.vue'

import atlasaktar from '../src/components/app/bilet/aktarimbilet/atlasaktarim.vue'
import bizitravelaktar from '../src/components/app/bilet/aktarimbilet/bizitravelaktarim.vue'
import bizitravelonlineaktar from '../src/components/app/bilet/aktarimbilet/bizitravelonlineaktarim.vue'

import otelfirsatiaktar from '../src/components/app/bilet/aktarimbilet/otelfirsatiaktarim.vue'
import biletbankaktar from '../src/components/app/bilet/aktarimbilet/biletbankaktarim.vue'
import biletallaktar from '../src/components/app/bilet/aktarimbilet/biletallaktarim.vue'


import excelaktar from '../src/components/app/bilet/aktarimbilet/excelaktarim.vue'
import turkmanairaktar from '../src/components/app/bilet/aktarimbilet/turkmanairaktarim.vue'

import arkmanxmlaktar from '../src/components/app/bilet/aktarimbilet/arkmanxmlaktarim.vue'
import arkmanxmlexport from '../src/components/app/bilet/aktarimbilet/arkmanxmlexport.vue'
import BiletAktarim from '../src/components/app/bilet/aktarimlar.vue'
import BiletGeciciVergi from '../src/components/app/bilet/gecicivergi.vue'
import BiletTanim from '../src/components/app/bilet/tanimlamalar.vue'
import Parkur from '../src/components/app/bilet/parkur.vue'
import BiletGunlukSatis from '../src/components/app/bilet/gunluksatisraporu.vue'
import AnalizRaporu from '../src/components/app/bilet/analizraporu.vue'
import SatisDagilimi from '../src/components/app/bilet/satisdagilimi.vue'
import CiroKarAnalizi from '../src/components/app/bilet/cirokaranalizi.vue'
import MukayeseliRapor from '../src/components/app/bilet/mukayeselirapor.vue'

import UcusRaporu from '../src/components/app/bilet/ucusraporu.vue'
import MusteriCiroIskonto from '../src/components/app/bilet/mustericiroveiskonto.vue'
import KesenkisiAnaliz from '../src/components/app/bilet/kesenkisianaliz.vue'

import BiletGelirDag from '../src/components/app/bilet/gelirdagilimiraporu.vue'
import TkDevreRaporu from '../src/components/app/bilet/raporlar/tkdevreraporu.vue'
import GenelDevreRaporu from '../src/components/app/bilet/raporlar/geneldevreraporu.vue'
import NonIAataDevreRaporu from '../src/components/app/bilet/raporlar/noniatadevreraporu.vue'
import IadeBiletFaturaKontrol from '../src/components/app/bilet/raporlar/iadebiletfatura.vue'
import BspDevreRaporu from '../src/components/app/bilet/raporlar/bspdevreraporu.vue'
import BorusanRaporu from '../src/components/app/bilet/raporlar/digerraporlar/borusan.vue'
import YolcumNerede from '../src/components/app/bilet/raporlar/yolcumnerede.vue'
import CoperYolcumNerede from '../src/components/app/coper/raporlar/otelyolcumnerede.vue'
import BAFormu from '../src/components/app/diger/baformu.vue'
import BSFormu from '../src/components/app/diger/bsformu.vue'
import PosMaliyet from '../src/components/app/diger/posmaliyetraporu.vue'
import BankaPosEkstresi from '../src/components/app/diger/bankaposekstresi.vue'

import MusteriKarlilik from '../src/components/app/diger/musterikarlilikraporu.vue'
import MusteriKarlilikOdeme from '../src/components/app/diger/musterikarlilikodeme.vue'
import Yaslandirmaİcmali from '../src/components/app/diger/yaslandirmaicmali.vue'
import HataYonetim from '../src/components/app/coper/diger/hatayonetim.vue'

import CiroRaporu from '../src/components/app/diger/ciroraporu.vue'
import CiroAnaliz from '../src/components/app/diger/ciroanaliz.vue'


import BiletGenelParametreler from '../src/components/app/bilet/genelparametreler.vue'
import BiletRaporParametreler from '../src/components/app/bilet/raporparametre.vue'
import BiletKesenKisi from '../src/components/app/bilet/kesenkisi.vue'
import pdfparametreler from './components/app/bilet/pdfparametreler.vue'



//Cari Linkler
//import cari from '../src/components/app/cari/form.vue'

import goster from '../src/components/app/cari/goster.vue'
import duzenle from '../src/components/app/cari/duzenle.vue'
import yeni from '../src/components/app/cari/yeni.vue'
import tumkayitlar from '../src/components/app/cari/tumkayitlar.vue'
import CariIndex from '../src/components/app/cari/index.vue'
import carikartGenelAmacliRapor from '../src/components/app/cari/carikartgenelamaclirapor.vue'
import CariYardimciIslemler from '../src/components/app/cari/yardimciislemler/index.vue'
import CariYardimciIslemlerCarisizBiletList from '../src/components/app/cari/yardimciislemler/carisizbiletlistesi.vue'
import CariHareketIndex from '../src/components/app/carihareketler/index.vue'

import CariHareketYeni from '../src/components/app/carihareketler/yeni.vue'
import CariHareketDuzenle from '../src/components/app/carihareketler/duzenle.vue'
import CariHareketExcel from '../src/components/app/cariaktarim/carihareket/excel.vue'
import CariExcel from '../src/components/app/cariaktarim/cari/carikartexcel.vue'


import Parametreler from '../src/components/app/parametreler/genelparametreler.vue'
import MasrafMerkezi from '../src/components/app/parametreler/masrafmerkezi.vue'
import Referans from '../src/components/app/parametreler/referans.vue'
import Evrak from '../src/components/app/parametreler/evrak.vue'
import Sirket from '../src/components/app/parametreler/sirket.vue'
import Bolum from '../src/components/app/parametreler/bolum.vue'
import Gib from '../src/components/app/parametreler/gib.vue'
import Gibearsiv from '../src/components/app/parametreler/gibseriearsiv.vue'
import HesapGurubu from '../src/components/app/parametreler/hesapgurubu.vue'
import Efaturadip from '../src/components/app/parametreler/efaturadip.vue'
import Webadresi from '../src/components/app/parametreler/webadresi.vue'
import Odemearaci from '../src/components/app/parametreler/odemearaci.vue'
import IstisnaKodu from '../src/components/app/parametreler/istisnakodu.vue'
import KdvOranHesap from '../src/components/app/parametreler/kdvoranhesap.vue'

import GenelTanitim from '../src/components/app/parametreler/geneltanitim.vue'
import TevkifatKodu from '../src/components/app/parametreler/tevkifatkodu.vue'
import OtelFiyatKodu from '../src/components/app/parametreler/otelfiyatkodu.vue'
import Odemesekliaciklama from '../src/components/app/parametreler/odemesekliaciklama.vue'
import SerbestFaturaYeni from '../src/components/app/fatura/serbestfatura.vue'
import SerbestFaturaCopy from '../src/components/app/fatura/faturakopya.vue'
import CoperGelenFatura from '../src/components/app/fatura/copergelenfatura.vue'
import KurGirisi from '../src/components/app/cari/kurgirisi.vue'
import FaturaSorgula from '../src/components/app/fatura/faturadurumusorgula.vue'
import gelenEFaturalariHavuzaKaydet from '../src/components/app/fatura/gelenEFaturalariHavuzaKaydet.vue'
import gelenEFaturaListesi from '../src/components/app/fatura/gelenEFaturaListesi.vue'
import gelenEFaturaIsle from '../src/components/app/fatura/gelenEFaturaIsle.vue'



import FaturaBasma from '../src/components/app/fatura/faturabasma.vue'
import EntegrasyonIndex from '../src/components/app/entegrasyon/index.vue'
import CariEnt from '../src/components/app/entegrasyon/carihareket/carient.vue'
import SerbestEnt from '../src/components/app/entegrasyon/serbestfatura/serbestent.vue'
import BiletEnt from '../src/components/app/entegrasyon/biletent.vue'
import BiletEntDetay from '../src/components/app/entegrasyon/biletentdetail.vue'
import BiletEntLineDetay from '../src/components/app/entegrasyon/biletentlinedetail.vue'
import BiletEntegre from '../src/components/app/entegrasyon/biletentegre.vue'
import CoperEntegre from '../src/components/app/entegrasyon/coperentegre.vue'

import Deneme1 from '../src/components/app/customcomp/deneme.vue'
import BankaPos from '../src/components/app/parametreler/bankapos.vue'
import YeniPos from '../src/components/app/parametreler/yenipos.vue'
import Analiz from '../src/components/app/parametreler/analiz.vue'
import Banka from '../src/components/app/parametreler/banka.vue'
import Doviz from '../src/components/app/parametreler/doviz.vue'
import Firma from '../src/components/app/parametreler/firma.vue'
import BorcluListesi from '../src/components/app/diger/borclulistesi.vue'
import MutabakatMektubu from '../src/components/app/diger/mutabakatmektubu.vue'
import SerbestFaturaAktarim from '../src/components/app/fatura/aktarimlar/serbestfaturaexcel.vue'
import CoperSatisIade from '../src/components/app/fatura/copersatisiade.vue'
import CoperSatisIadeIslem from '../src/components/app/fatura/copersatisiadeislem.vue'


import KasaListesi from '../src/components/app/diger/kasaraporu.vue'
import CaritanimGenel from '../src/components/app/tanimlamalar/genel.vue'
import CaritanimSirket from '../src/components/app/tanimlamalar/sirket.vue'
import MizanCari from '../src/components/app/mizan/carihesap.vue'
import MizanMasraf from '../src/components/app/mizan/masrafmerkezi.vue'
import MizanReferans from '../src/components/app/mizan/referans.vue'
import MizanDoviz from '../src/components/app/mizan/doviz.vue'
import EkstreHesap from '../src/components/app/ekstreler/hesabagore.vue'

import EkstreTarih from '../src/components/app/ekstreler/tarihegore.vue'
import EkstreReferans from '../src/components/app/ekstreler/referansagore.vue'
import EkstreMasraf from '../src/components/app/ekstreler/masrafmerkezinegore.vue'
import EkstreFirmaKart from '../src/components/app/ekstreler/firmakartinagore.vue'
import MusteriPersonel from '../src/components/app/ekstralar/musteri-personel.vue'
import Profilsablon from '../src/components/app/ekstralar/profilsablon.vue'
import Profilsablonveri from '../src/components/app/ekstralar/sablonverigirisi.vue'
import FaturaListesiYeni from '../src/components/app/fatura/faturalistesi.vue'
import FaturaListesiEntegrasyon from '../src/components/app/fatura/faturaentegrasyon.vue'


import comptest from '../src/components/app/fatura/comptest.vue'

import GelenFaturaListesi from '../src/components/app/fatura/gelenfaturalistesi.vue'
import SaticiOdemeListesi from '../src/components/app/coper/odemeler/saticiodemelistesi.vue'
import FaturaTanimlamalarYeni from '../src/components/app/fatura/tanimlamalar.vue'
import FaturaAyarlar from '../src/components/app/fatura/ayarlar.vue'

import Faturaxslt from '../src/components/app/fatura/faturaxslt.vue'
import FaturadizaynDuzenle from '../src/components/app/fatura/faturadizaynduzenle.vue'
import FaturadizaynTanimla from '../src/components/app/fatura/faturadizayntanimlama.vue'
import FaturaDetay from '../src/components/app/fatura/faturadetay.vue'
import CoperTopluFatura from '../src/components/app/fatura/copertoplufatura.vue'
import CoperTopluFaturaIslem from '../src/components/app/fatura/copertoplufaturaislem.vue'
import CoperIade from '../src/components/app/fatura/coperiade.vue'

//ek urunler
import EkUrunler from '../src/components/app/urunler/ekurunler.vue'
import TestJs from '../src/components/app/test/test.vue'




//Coper başla
import exceladresaktarim from './components/app/coper/tanitimlar/exceladresaktarim.vue'
import coperbizitravelaktarim from '../src/components/app/coper/aktarim/coperbizitravelaktarim.vue'
import coperarkmanotelrezaktarim from '../src/components/app/coper/aktarim/coperarkmanotelrezaktarim.vue'
import coperOtelFirsatiAktarim from '../src/components/app/coper/aktarim/coperotelfirsatiaktarim.vue'
import coperBookingAgoraAktarim from '../src/components/app/coper/aktarim/coperbookingagoraaktarim.vue'
import coperJuniperAktarim from '../src/components/app/coper/aktarim/coperjuniperaktarim.vue'
import coperbizitravelonlineaktarim from '../src/components/app/coper/aktarim/coperbizitravelonlineaktarim.vue'
import otelList from '../src/components/app/coper/otel/index.vue'
import rentacarList from '../src/components/app/coper/rentacar/index.vue'
import muzeList from '../src/components/app/coper/muze/index.vue'
import charterList from '../src/components/app/coper/charter/index.vue'
import transferList from '../src/components/app/coper/transfer/index.vue'
import restaurantList from '../src/components/app/coper/restaurant/index.vue'
import acenteList from '../src/components/app/coper/acente/index.vue'
import rehberList from '../src/components/app/coper/rehber/index.vue'
import gemiList from '../src/components/app/coper/gemi/index.vue'
import digerList from '../src/components/app/coper/diger/index.vue'
import vizeList from '../src/components/app/coper/vize/index.vue'
import vizeYeni from '../src/components/app/coper/vize/yeni.vue'
import turoperatoruList from '../src/components/app/coper/turoperator/index.vue'
import sigortaList from '../src/components/app/coper/sigorta/index.vue'
import feribotList from '../src/components/app/coper/feribot/index.vue'
import golfList from '../src/components/app/coper/golf/index.vue'
import coperrezervasyonListesi from '../src/components/app/coper/rezervasyonlistesi.vue'
import coperrezervasyonListesiGuncel from '../src/components/app/coper/rezervasyon/rezervasyonlistesi.vue'
import CoperRezervasyon from '../src/components/app/coper/rezervasyon/index.vue'
import MiceRezervasyon from '../src/components/app/coper/mice/index.vue'
import VoucherForm from '../src/components/app/coper/page/formlar/voucher.vue'
import KotasyonFormu from '../src/components/app/coper/page/formlar/kotasyonformu.vue'
import GelenFaturaListesiCoper from '../src/components/app/coper/page/formlar/gelenfaturalistesi.vue'
import OtelRezervasyonForm from '../src/components/app/coper/page/formlar/otelrezervasyonfisi.vue'
import OtelFaturaForm from '../src/components/app/coper/page/formlar/fatura.vue'
import CoperSatisRaporu from '../src/components/app/coper/raporlar/satisraporu.vue'

import KesenKisiRapor from '../src/components/app/diger/kesenkisirapor.vue'
import CoperKarlilikRaporu from '../src/components/app/coper/raporlar/karlilikraporu.vue'
import CoperOdemeRaporu from '../src/components/app/coper/raporlar/odemeraporu.vue'
import GunlukTurListesi from '../src/components/app/coper/raporlar/gunlukturlistesi.vue'
import TransferIsimListesi from '../src/components/app/coper/raporlar/transferisimlistesi.vue'
import CoperFaturasiGelenGelmeyen from '../src/components/app/coper/raporlar/faturasigelengelmeyen.vue'
import CoperGenelAmacliRapor from '../src/components/app/coper/raporlar/genelamacliraporcoper.vue'



import UcusListe from '../src/components/app/satis/ucak/liste.vue'

import UcusIslem from '../src/components/app/satis/ucak/islem.vue'
import UcusRezListe from '../src/components/app/satis/ucak/rezervasyonliste.vue'

import CoperKomisyonRaporu from '../src/components/app/coper/komisyonfaturasi/index.vue'
import CoperKomisyonFaturaIslem from '../src/components/app/coper/komisyonfaturasi/faturaislem.vue'
import SaticiIslem from '../src/components/app/coper/saticilar/islem.vue'
import SaticiGoster from '../src/components/app/coper/saticilar/goster.vue'
import arkmanmapping from '../src/components/app/coper/saticilar/mapping.vue'
import HotelRunnerList from '../src/components/app/hotelrunner/index.vue'
import HotelRunnerEkle from '../src/components/app/hotelrunner/oteltanitim/ekle.vue'
import HotelRunnerOtelList from '../src/components/app/hotelrunner/oteltanitim/list.vue'
import HotelRunnerGuncelle from '../src/components/app/hotelrunner/oteltanitim/update.vue'
import HotelRunnerOtelIslem from '../src/components/app/hotelrunner/otelislem.vue'
import HotelRunnerRezervasyon from '../src/components/app/hotelrunner/rezervasyon.vue'
import saticitanit from '../src/components/app/coper/page/tanitimlar/saticitanit.vue'
//import saticilist from '../src/components/app/coper/page/tanitimlar/saticilist.vue'
import saticilar from '../src/components/app/coper/page/tanitimlar/saticilar.vue'
import PaxDriveList from '../src/components/app/coper/paxdrive/index.vue'
import PaxDriveTransferIslem from '../src/components/app/coper/paxdrive/transferislem.vue'
import PaxDriveTransferList from '../src/components/app/coper/paxdrive/transferliste.vue'
import Clinista from '../src/components/app/coper/clinista/index.vue'
import ClinistaTakvim from '../src/components/app/coper/clinista/clinistatakvim.vue'
import ClinistaAcenteTakvim from '../src/components/app/coper/clinista/acentetakvim.vue'
import ClinistaListe from '../src/components/app/coper/clinista/isteklistesi.vue'
import ClinistaAcenteListe from '../src/components/app/coper/clinista/acenteisteklistesi.vue'
import ClinistaIslem from '../src/components/app/coper/clinista/istekislem.vue'
import ClinistaAcenteIslem from '../src/components/app/coper/clinista/acenteistekislem.vue'
import Takvim from '../src/components/app/takvim/takvim.vue'
import Versiyonlar from '../src/components/app/versiyonlar/index.vue'


import saticitumkayitlar from '../src/components/app/coper/page/tanitimlar/saticitumkayitlar.vue'
import rezervasyon from '../src/components/app/coper/page/rezervasyon/rezervasyon.vue'
import coperSirket from '../src/components/app/coper/page/tanitimlar/sirket.vue'
import coperParametreler from '../src/components/app/coper/page/tanitimlar/parametreler.vue'
import coperAdresListesi from '../src/components/app/coper/tanitimlar/adreslistesi.vue'
import coperOtelKategori from '../src/components/app/coper/tanitimlar/otelkategori.vue'
import coperOdemeListesi from '../src/components/app/coper/tanitimlar/odeme.vue'
import coperAdres from '../src/components/app/coper/tanitimlar/adres.vue'
import CoperParametreList from '../src/components/app/coper/tanitimlar/parametreler.vue'
import ParametreTanitim from '../src/components/app/coper/tanitimlar/parametretanitim.vue'
import coperOtelListesi from '@/components/app/coper/tanitimlar/Otellistesi/otellistesi.vue'
import coperOtelIslem from '@/components/app/coper/tanitimlar/Otellistesi/otelislem.vue'
import coperAcenteKomisyon from  '@/components/app/coper/tanitimlar/acentekomisyon.vue'
import coperKarlilik from  '@/components/app/coper/tanitimlar/karlilik.vue'
import coperVizeFiyat from '@/components/app/coper/tanitimlar/vizefiyat/index.vue'
import coperVizeFiyatIslem from '@/components/app/coper/tanitimlar/vizefiyat/islem.vue'
//import rezervasyonyeni from '../src/components/app/coper/page/rezervasyon/rezervasyon.vue'
import genelamacli from '../src/components/app/bilet/raporlar/genelamacli.vue'
import yeniGenelamacli from '../src/components/app/bilet/raporlar/genelamaclirapor.vue'
import yeniCariGenelamacli from '../src/components/app/diger/carigenelamaclirapor.vue'

import genelamaclicari from '../src/components/app/diger/genelamaclicari.vue'
import vizeTakipListesi from '@/components/app/coper/raporlar/vizetakiplistesi.vue'
import coperOdaTipleri from '@/components/app/coper/tanitimlar/odatipleri.vue'
import coperPaketTurEkHizmet from '@/components/app/coper/tanitimlar/paketekhizmet.vue'
import coperTurEtiket from '@/components/app/coper/tanitimlar/turetiket.vue'

//Coper bitiş

//EFatura Başla
import samplepage from '../src/components/app/efatura/samplepage.vue'
import efatura from '../src/components/app/efatura/efatura.vue'
import mukellefsorgu from '../src/components/app/efatura/mukellefsorgu.vue'
import faturadurumusorgula from '../src/components/app/efatura/faturadurumusorgula.vue'



import { id } from 'postcss-selector-parser';
//EFatura Bitiş

//Muhasebe Başla

import muhasebeYardimcilar from '../src/components/app/muhasebe/yardimcilar/index.vue'
import muhasebeParametreler from '../src/components/app/muhasebe/parametreler/index.vue'
import muhasebeTanimlamalarSirketTanitim from '../src/components/app/muhasebe/tanimlamalar/sirkettanitim.vue'
import muhasebeTanimlamalarMerkezTanitim from '../src/components/app/muhasebe/tanimlamalar/merkeztanitim.vue'
import muhasebeTanimlamalarFisTipiTanitim from '../src/components/app/muhasebe/tanimlamalar/fistipitanitim.vue'
import muhasebeTanimlamalar from '../src/components/app/muhasebe/tanimlamalar/index.vue'
import muhasebeKodlari from '../src/components/app/muhasebe/muhasebekodlari/index.vue'
import muhasebetevkifatbaglanti from '../src/components/app/muhasebe/muhasebekodlari/tevkifatbaglanti.vue'
import muhasebeKodlariIslem from '../src/components/app/muhasebe/muhasebekodlari/islem.vue'
import muhasebeKodlariListe from '../src/components/app/muhasebe/muhasebekodlari/liste.vue'
import muhasebeFislerListe  from '../src/components/app/muhasebe/fisler/liste.vue'
import muhasebeFislerDetay from '../src/components/app/muhasebe/fisler/detay.vue'
import muhasebeFislerIslem from '../src/components/app/muhasebe/fisler/islem.vue'
import muhasebeRaporHesap from '../src/components/app/muhasebe/raporlar/hesabagore.vue'
import muhasebeRaporBilancoRapor from '../src/components/app/muhasebe/raporlar/bilancorapor.vue'
import muhasebeRaporBilancoFormat from '../src/components/app/muhasebe/raporlar/bilancoformat.vue'
import muhasebeRaporBeyannameRapor from '../src/components/app/muhasebe/raporlar/beyannamerapor.vue'
import muhasebeRaporBeyannameFormat from '../src/components/app/muhasebe/raporlar/beyannameformat.vue'
import muhasebeRaporGelirGiderRapor from '../src/components/app/muhasebe/raporlar/gelirgiderrapor.vue'
import muhasebeRaporGelirGiderFormat from '../src/components/app/muhasebe/raporlar/gelirgiderformat.vue'

import muhasebeBorcYaslandirma from '../src/components/app/muhasebe/raporlar/borcyaslandirma.vue'
import muhasebeAlacakYaslandirma from '../src/components/app/muhasebe/raporlar/alacakyaslandirma.vue'
 import muhasebeRaporReferans from '../src/components/app/muhasebe/raporlar/referansagore.vue'
import muhasebeRaporMizan from '../src/components/app/muhasebe/raporlar/mizan.vue'
import muhasebereferansMizan from '../src/components/app/muhasebe/raporlar/referansmizan.vue'
import muhasebeRaporYekunKontrolu from '../src/components/app/muhasebe/raporlar/yekunkontrolu.vue'
import muhasebeResmiDefterOlustur from '../src/components/app/muhasebe/resmidefter/defterolustur.vue'
import muhasebeResmiDefterSil from '../src/components/app/muhasebe/resmidefter/deftersil.vue'
import mukerrerfiskontrol from '../src/components/app/muhasebe/resmidefter/mukerrerfiskontrol.vue'
import schematronkontrol from '../src/components/app/muhasebe/resmidefter/schematronkontrol.vue'
//Muhasebe Bitiş
import task from '../src/components/app/task/task.vue'
import edefterexport from '../src/components/app/muhasebe/edefter/edefterexport.vue'
import dinamikparametre from '../src/components/app/muhasebe/parametreler/dinamikparametre.vue'
import testDeneme from '../src/components/app/test/deneme.vue'


import yardim from '../src/components/app/diger/yardim.vue'
import videos from '../src/components/app/diger/videos.vue'
import kesenkisirapor from '../src/components/app/diger/kesenkisirapor.vue'
//Paket Tur
import masterpaket from '../src/components/app/pakettur/masterpaket.vue'
import masterpaketislem from '../src/components/app/pakettur/masterpaketislem.vue'
import turara from '../src/components/app/pakettur/turara.vue'
import turdetay from '../src/components/app/pakettur/turdetay.vue'
import turrezervasyon from '../src/components/app/pakettur/turrezervasyon.vue'
import turrezervasyonlist from '../src/components/app/pakettur/turrezervasyonlist.vue'

import turaltpaket from '../src/components/app/pakettur/turaltpaket.vue'
import turaltpaketislem from '../src/components/app/pakettur/turaltpaketislem.vue'

import onlinebankahareketleri from '../src/components/app/bankaentegrasyon/bankahareketleri.vue'
import CariYardimciIslemlerMuhKodUpdate from '../src/components/app/cari/yardimciislemler/carikartmuhkodupdateexcel.vue'

//----

 import logkayitlari from '../src/components/app/destek/logkayitlari.vue'

Vue.use(Router)

const router = new Router({
  routes: [
   
   { path: '/destek/logkayitlari', name: 'logkayitlari', component: logkayitlari, meta: { requiresAuth: false }  },
    { path: '/customcomp/stripereturn', name: 'stripereturn', component: stripereturn, meta: { requiresAuth: false }  },
//Paket-Tur
{ path: '/pakettur/masterpaket', name: 'masterpaket', component: masterpaket, meta: { requiresAuth: false }  },
{ path: '/pakettur/masterpaketislem/:islem', name: 'masterpaketislem', component: masterpaketislem, meta: { requiresAuth: false }  },
{ path: '/pakettur/turara', name: 'turara', component: turara, meta: { requiresAuth: false }  },
{ path: '/pakettur/turdetay', name: 'turdetay', component: turdetay, meta: { requiresAuth: false }  },
{ path: '/pakettur/turrezervasyon', name: 'turrezervasyon', component: turrezervasyon, meta: { requiresAuth: false }  },
{ path: '/pakettur/turrezervasyonlist', name: 'turrezervasyonlist', component: turrezervasyonlist, meta: { requiresAuth: false }  },

{ path: '/pakettur/turaltpaket', name: 'turaltpaket', component: turaltpaket, meta: { requiresAuth: false }  },
{ path: '/pakettur/turaltpaketislem/:islem', name: 'turaltpaketislem', component: turaltpaketislem, meta: { requiresAuth: false }  },
//paket-tur-bitis

    { path: '/login', name: 'login', component: Login },
    { path: '/confirm/:id', name: 'confirm', component: Confirm },
    { path: '/anasirket', name: 'anasirket', component: Anasirket  },
    { path: '/urunsatinal', name: 'urunsatinal', component: Urunler },
    { path: '/account/urunler/:id', name: 'urunsatis', component: UrunSatis },
    { path: '/uye/index', name: 'login-uye', component: LoginUye },
    { path: '/uye/yetkigrup/:id', name: 'login-yetkigrup', component: UyeYetkiGrup },
    { path: '/uye/yetkigruplistesi', name: 'login-yetkigruplist', component: UyeYetkiGrupList },
    { path: '/uye/detay/:id', name: 'uye-detay', component: UyeDetay },
    { path: '/uye/yeni', name: 'uye-yeni', component: UyeYeni },

    
    { path: '/', name: 'home', component: Home, meta: { requiresAuth: true } },
   // { path: '/cari/form', name: 'cari', component: cari, meta: { requiresAuth: true }  },
    { path: '/cari/CustomerPersonelPage', name: 'cari-personel', component: CariPersonel, meta: {requiresAuth: true}},
    { path: '/cari/goster/:id', name: 'goster', component: goster, meta: { requiresAuth: true }  },
    { path: '/cari/duzenle/:id', name: 'duzenle', component: duzenle, meta: { requiresAuth: true }  },
    { path: '/cari/yeni', name: 'yeni', component: yeni, meta: { requiresAuth: true }  },
    { path: '/cari/tumkayitlar', name: 'tumkayitlar', component: tumkayitlar, meta: { requiresAuth: true }  },
    { path: '/cari/yardimciislemler/index', name: 'yardimci-islemler', component: CariYardimciIslemler, meta: { requiresAuth: true }  },
    { path: '/cari/yardimciislemler/carisizbiletlistesi', name: 'yardimci-islemler-carisizbiletlistesi', component: CariYardimciIslemlerCarisizBiletList, meta: { requiresAuth: true }  },
    { path: '/cari/yardimciislemler/muhasebekodupdate', name: 'yardimci-islemler-muhasebekodupdate', component: CariYardimciIslemlerMuhKodUpdate, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel', name: 'genelparametreler', component: Parametreler, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/referans', name: 'referans', component: Referans, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/doviz', name: 'doviz', component: Doviz, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/evrak', name: 'evrak', component: Evrak, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/analiz', name: 'analiz', component: Analiz, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/banka', name: 'banka', component: Banka, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/sirket', name: 'sirket', component: Sirket, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/bolum', name: 'bolum', component: Bolum, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/gib', name: 'gib', component: Gib, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/gibseriearsiv', name: 'gibseriearsiv', component: Gibearsiv, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/hesapgurubu', name: 'hesapgurubu', component: HesapGurubu, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/efaturadip', name: 'efaturadip', component: Efaturadip, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/webadresi', name: 'webadresi', component: Webadresi, meta: { requiresAuth: true }  },
    { path: '/customcomp/deneme', name: 'deneme', component: Deneme1, meta: { requiresAuth: true }  },
    
    { path: '/parametreler/genel/geneltanitim/:id', name: 'geneltanitim', component: GenelTanitim, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/odemearaci', name: 'odemearaci', component: Odemearaci, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/istisnakodu', name: 'istisnaaciklama', component: IstisnaKodu, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/kdvoranhesap', name: 'kdvoranhesap', component: KdvOranHesap, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/otelfiyatkodu', name: 'otelfiyatkodu', component: OtelFiyatKodu, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/tevkifatkodu', name: 'tevkifatkodu', component: TevkifatKodu, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/odemesekliaciklama', name: 'odemesekliaciklama', component: Odemesekliaciklama
    , meta: { requiresAuth: true }  },
    { path: '/fatura/faturabasma', name: 'fatura-basma', component: FaturaBasma, meta: { requiresAuth: true } },

    { path: '/ekstralar/musteripersonel', name: 'ekstra-musteri', component: MusteriPersonel, meta: { requiresAuth: true }  },
    { path: '/ekstralar/profilsablon', name: 'ekstralar-profilsablon', component: Profilsablon, meta: { requiresAuth: true }  },
    { path: '/ekstralar/sablonverigirisi', name: 'ekstralar-verigirisi', component: Profilsablonveri, meta: { requiresAuth: true }  },

    { path: '/odeme/hata', name: 'hataodeme', component: HataOdeme },
    { path: '/odeme/basarili', name: 'basarili', component: BasariliOdeme},
    { path: '/odeme/sonuc/:id', name: 'odeme-sonuc', component: OdemeSonuc},
   


    { path: '/parametreler/genel/bankapos', name: 'bankapos', component: BankaPos, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/bankapos/:id', name: 'yenipos', component: YeniPos, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/firma', name: 'firma', component: Firma, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/masrafmerkezi', name: 'masrafmerkezi', component: MasrafMerkezi, meta: { requiresAuth: true } },
    { path: '/cari/index', name: 'cari-index', component: CariIndex, meta: { requiresAuth: true } },
    { path: '/cari/kurgirisi', name: 'kurgirisi', component: KurGirisi, meta: { requiresAuth: true } },
    { path: '/cari/carikartgenelamaclirapor', name: 'cari-carikartgenelamaclirapor', component: carikartGenelAmacliRapor, meta: { requiresAuth: true } },
    { path: '/carihareketler/index', name: 'carihareketler-index', component: CariHareketIndex, meta: { requiresAuth: true } },
    { path: '/carihareketler/yeni', name: 'carihareketler-yeni', component: CariHareketYeni, meta: { requiresAuth: true } },
    { path: '/carihareketler/duzenle/:id', name: 'carihareketler-duzenle', component: CariHareketDuzenle, meta: { requiresAuth: true } },
    { path: '/cariaktarim/carihareket/excel', name: 'aktarim-carihareket-excel', component: CariHareketExcel, meta: { requiresAuth: true } },
    { path: '/cariaktarim/cari/carikartexcel', name: 'aktarim-cari-excel', component: CariExcel, meta: { requiresAuth: false } },
    { path: '/diger/mutabakatmektubu', name: 'mutabakat-mektubu', component: MutabakatMektubu, meta: { requiresAuth: true }  },
    { path: '/entegrasyon/index', name: 'entegrasyon-index', component: EntegrasyonIndex, meta: { requiresAuth: true }  },
    { path: '/entegrasyon/biletent', name: 'muhasebe-entegrasyon-bilet', component: BiletEnt, meta: { requiresAuth: true }  },
    { path: '/entegrasyon/biletentdetail/:id', name: 'muhasebe-entegrasyon-bilet-detay', component: BiletEntDetay, meta: { requiresAuth: true }  },
    { path: '/entegrasyon/biletentlinedetail/:id', name: 'muhasebe-entegrasyon-bilet-line-detay', component: BiletEntLineDetay, meta: { requiresAuth: true }  },
    { path: '/entegrasyon/biletentegre', name: 'muhasebe-entegrasyon-bilet-entegre', component: BiletEntegre, meta: { requiresAuth: true }  },
    { path: '/coper/coperentegre', name: 'muhasebe-entegrasyon-coper', component: CoperEntegre, meta: { requiresAuth: true }  },
    { path: '/coper/excelaktarim/saticiaktarim', name: 'coper-excel-aktarimi', component: ExcelSaticiAktarim, meta: { requiresAuth: false }  },
    
    { path: '/entegrasyon/carihareket/carient', name: 'muhasebe-entegrasyon-carihareket', component: CariEnt, meta: { requiresAuth: true }  },
    { path: '/entegrasyon/serbestfatura/serbestent', name: 'muhasebe-entegrasyon-serbestfatura-entegre', component: SerbestEnt, meta: { requiresAuth: true }  },

    

    { path: '/diger/genelamaclicari', name: 'genelamaclicari', component: genelamaclicari, meta: { requiresAuth: true }  },
    { path: '/diger/carigenelamaclirapor', name: 'carigenelamaclirapor', component: yeniCariGenelamacli, meta: { requiresAuth: true }  },

    { path: '/diger/borclulistesi', name: 'borclu-liste', component: BorcluListesi, meta: { requiresAuth: true }  },
    { path: '/diger/kasaraporu', name: 'kasa-liste', component: KasaListesi, meta: { requiresAuth: true }  },
    { path: '/tanimlamalar/genel', name: 'parametre-genel', component: CaritanimGenel, meta: { requiresAuth: true }  },
    { path: '/tanimlamalar/sirket', name: 'parametre-sirket', component: CaritanimSirket, meta: { requiresAuth: true }  },
    { path: '/mizan/carihesap', name: 'mizan-carihesap', component: MizanCari, meta: { requiresAuth: true }  },
    { path: '/mizan/masrafmerkezi', name: 'mizan-masrafmerkezi', component: MizanMasraf, meta: { requiresAuth: true }  },
    { path: '/mizan/referans', name: 'mizan-referans', component: MizanReferans, meta: { requiresAuth: true }  },
    { path: '/mizan/doviz', name: 'mizan-doviz', component: MizanDoviz, meta: { requiresAuth: true }  },
    { path: '/ekstreler/hesabagore', name: 'ekstre-hesap', component: EkstreHesap, meta: { requiresAuth: true }  },
    { path: '/ekstreler/tarihegore', name: 'ekstre-tarih', component: EkstreTarih, meta: { requiresAuth: true }  },
    { path: '/ekstreler/referansagore', name: 'ekstre-referans', component: EkstreReferans, meta: { requiresAuth: true }  },
    { path: '/ekstreler/masrafmerkezinegore', name: 'ekstre-masraf', component: EkstreMasraf, meta: { requiresAuth: true }  },
    { path: '/ekstreler/firmakartinagore', name: 'ekstre-firmakart', component: EkstreFirmaKart, meta: { requiresAuth: true }  },
    { path: '/bilet/yeni/:id', name: 'bilet-yeni', component: BiletIndex, meta: { requiresAuth: true } },
    { path: '/bilet/faturalibiletduzenle/:id', name: 'bilet-faturalibiletduzenle', component: Faturalibiletduzenle, meta: { requiresAuth: true } },
    { path: '/bilet/biletiade/:id', name: 'bilet-iade', component: BiletIade, meta: { requiresAuth: true } },
    { path: '/bilet/tanimlamalar', name: 'bilet-tanimlamalar', component: BiletTanim, meta: { requiresAuth: true } },
    { path: '/bilet/gecicivergi', name: 'bilet-gecicivergi', component: BiletGeciciVergi, meta: { requiresAuth: true } },
    { path: '/bilet/genelparametreler', name: 'bilet-genelparametreler', component: BiletGenelParametreler, meta: { requiresAuth: true } },
    { path: '/bilet/raporparametre', name: 'bilet-raporparametre', component: BiletRaporParametreler, meta: { requiresAuth: true } },
    { path: '/bilet/kesenkisi', name: 'bilet-kesenkisi', component: BiletKesenKisi, meta: { requiresAuth: true } },
    { path: '/download/index', name: 'download-page', component: DownloadPage, meta: { requiresAuth: true } },

    { path: '/bilet/index', name: 'bilet-listesi', component: BiletListe, meta: { requiresAuth: true } },
    { path: '/bilet/indexIntegrate', name: 'bilet-alis-entegre', component: BiletAlisEntegre, meta: { requiresAuth: false } },
    { path: '/bilet/voidlistesi', name: 'void-listesi', component: VoidListe, meta: { requiresAuth: true } },
    { path: '/bilet/iadelistesi', name: 'iade-listesi', component: IadeListe, meta: { requiresAuth: true } },

    { path: '/bilet/aktarimlar', name: 'bilet-aktarimlar', component: BiletAktarim, meta: { requiresAuth: true } },
    { path: '/bilet/parkur', name: 'parkur', component: Parkur, meta: { requiresAuth: true }  },
    { path: '/bilet/gunluksatisraporu', name: 'bilet-gunluksatisraporu', component: BiletGunlukSatis, meta: { requiresAuth: true }  },
    { path: '/bilet/analizraporu', name: 'bilet-analizraporu', component: AnalizRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/ucusraporu', name: 'bilet-ucusraporu', component: UcusRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/mustericiroveiskonto', name: 'bilet-mustericiroveiskonto', component: MusteriCiroIskonto, meta: { requiresAuth: true }  },
    { path: '/bilet/kesenkisianaliz', name: 'bilet-kesenkisianaliz', component: KesenkisiAnaliz, meta: { requiresAuth: true }  },

    { path: '/bilet/gelirdagilimiraporu', name: 'bilet-gelirdagilimiraporu', component: BiletGelirDag, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/tkdevreraporu', name: 'bilet-tkdevreraporu', component: TkDevreRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/geneldevreraporu', name: 'bilet-geneldevreraporu', component: GenelDevreRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/noniatadevreraporu', name: 'bilet-noniatadevreraporu', component: NonIAataDevreRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/iadebiletfatura', name: 'bilet-iadebiletfatura', component: IadeBiletFaturaKontrol, meta: { requiresAuth: true }  },
    { path: '/bilet/satisdagilimi', name: 'bilet-satisdagilimi', component: SatisDagilimi, meta: { requiresAuth: true }  },
    { path: '/bilet/mukayeselirapor', name: 'bilet-mukayeselirapor', component: MukayeseliRapor, meta: { requiresAuth: true }  },

    { path: '/bilet/cirokaranalizi', name: 'cirokaranalizi', component: CiroKarAnalizi, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/bspdevreraporu', name: 'bilet-bspdevreraporu', component: BspDevreRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/digerraporlar/borusan', name: 'bilet-diger-borusan', component: BorusanRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/yolcumnerede', name: 'bilet-yolcumnerede', component: YolcumNerede, meta: { requiresAuth: false }  },
   
    { path: '/diger/bsformu', name: 'bsformu', component: BSFormu, meta: { requiresAuth: true }  },
    { path: '/diger/baformu', name: 'baformu', component: BAFormu, meta: { requiresAuth: true }  },
    { path: '/diger/ciroraporu', name: 'ciroraporu', component: CiroRaporu, meta: { requiresAuth: true }  },
    { path: '/diger/ciroanaliz', name: 'ciroanaliz', component: CiroAnaliz, meta: { requiresAuth: true }  },
    { path: '/diger/bankaposekstresi', name: 'bankaposekstresi', component: BankaPosEkstresi, meta: { requiresAuth: true }  },

    { path: '/diger/posmaliyetraporu', name: 'posmaliyet', component: PosMaliyet, meta: { requiresAuth: true }  },
    { path: '/diger/musterikarlilikraporu', name: 'musterikarlilik', component: MusteriKarlilik, meta: { requiresAuth: true }  },
    { path: '/diger/musterikarlilikodeme', name: 'musterikarlilikodeme', component: MusteriKarlilikOdeme, meta: { requiresAuth: true }  },
    { path: '/diger/yaslandirmaicmali', name: 'yaslandirmaicmali', component: Yaslandirmaİcmali, meta: { requiresAuth: true }  },
    { path: '/coper/diger/hatayonetim', name: 'hatayonetim', component: HataYonetim, meta: { requiresAuth: true }  },

    { path: '/bilet/biletaktarim/thyaktarim', name: 'thy-aktarim', component: THYAktarim, meta: { requiresAuth: true } },
    { path: '/bilet/biletaktarim/thyaktarimxml', name: 'thy-aktarim-xml', component: THYAktarimXml, meta: { requiresAuth: true } },
    
    { path: '/bilet/biletaktarim/juniperaktarim', name: 'juniper-aktarim', component: JuniperAktarim, meta: { requiresAuth: true } },

    { path: '/bilet/aktarimbilet/amadeusaktarim', name: 'amadeus-aktarim', component: AmadeusAktarim, meta: { requiresAuth: true } },
    { path: '/bilet/aktarimbilet/amadeusaktarimftp', name: 'amadeus-aktarimftp', component: AmadeusAktarimFtp, meta: { requiresAuth: true } },
    { path: '/bilet/aktarimbilet/ajetaktarim', name: 'ajetaktar', component: ajetaktar, meta: { requiresAuth: false }  },
    { path: '/bilet/aktarimbilet/ajetaktarimxml', name: 'ajetaktarimxml', component: ajetaktarimxml, meta: { requiresAuth: false }  },
    { path: '/bilet/aktarimbilet/pegasusaktarim', name: 'pegasusaktar', component: pegasusaktar, meta: { requiresAuth: false }  },
    { path: '/bilet/aktarimbilet/pegasusonlineaktarim', name: 'pegasusonlineaktar', component: pegasusonlineaktar, meta: { requiresAuth: false }  },
    
    { path: '/bilet/aktarimbilet/baseaktarim', name: 'baseaktar', component: baseaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/onurairaktarim', name: 'onurairaktar', component: onuraktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/sunexpressaktar', name: 'sunexpressaktar', component: sunexpressaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/freebirdaktar', name: 'freebirdaktar', component: freebirdaktar, meta: { requiresAuth: false }  },
    { path: '/bilet/aktarimbilet/iatiaktar', name: 'iatiaktar', component: iatiaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/galileoaktar', name: 'galileoaktar', component: galileoaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/sabreaktar', name: 'sabreaktar', component: sabreaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/bookingagoraaktar', name: 'bookingagoraaktar', component: bookingagoraaktar, meta: { requiresAuth: true }  },
     { path: '/bilet/aktarimbilet/lydiaaktar', name: 'lydiaaktar', component: lydiaaktar, meta: { requiresAuth: true }  },
    
    { path: '/bilet/aktarimbilet/atlasaktar', name: 'atlasaktar', component: atlasaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/bizitravelaktar', name: 'bizitravelaktar', component: bizitravelaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/bizitravelonlineaktar', name: 'bizitravelonlineaktar', component: bizitravelonlineaktar, meta: { requiresAuth: true }  },
    
    { path: '/bilet/aktarimbilet/otelfirsatiaktar', name: 'otelfirsatiaktar', component: otelfirsatiaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/biletbankaktar', name: 'biletbankaktar', component: biletbankaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/biletallaktar', name: 'biletallaktar', component: biletallaktar, meta: { requiresAuth: true }  },

    { path: '/bilet/aktarimbilet/excelaktar', name: 'excelaktar', component: excelaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/turkmanairaktar', name: 'turkmanairaktar', component: turkmanairaktar, meta: { requiresAuth: true }  },
    
    { path: '/bilet/aktarimbilet/arkmanxmlaktar', name: 'arkmanxmlaktar', component: arkmanxmlaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/arkmanxmlexport', name: 'arkmanxmlexport', component: arkmanxmlexport, meta: { requiresAuth: true }  },

    { path: '/bilet/raporlar/genelamacli', name: 'genelamacli', component: genelamacli, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/genelamaclirapor', name: 'genelamaclirapor', component: yeniGenelamacli, meta: { requiresAuth: true }  },
    {path:'/bilet/pdfparametreler',name:'bilet-pdfparametreler', component: pdfparametreler,meta:{requiresAuth: true}},

//fatura
{ path: '/fatura/comptest', name: 'comptest', component: comptest, meta: { requiresAuth: false }  },
{ path: '/fatura/faturadetay/:id', name: 'faturadetay', component: FaturaDetay, meta: { requiresAuth: true }  },
{ path: '/fatura/faturalistesi', name: 'faturalistesi', component: FaturaListesiYeni, meta: { requiresAuth: true }  },
{ path: '/fatura/gelenfaturalistesi', name: 'gelenfaturalistesi', component: GelenFaturaListesi, meta: { requiresAuth: true }  },
{ path: '/fatura/serbestfatura/:id', name: 'fatura-serbestyeni', component: SerbestFaturaYeni, meta: { requiresAuth: true } },

{ path: '/fatura/faturakopya/:id', name: 'fatura-serbestyeni', component: SerbestFaturaCopy, meta: { requiresAuth: false } },
{ path: '/fatura/copergelenfatura/:id', name: 'fatura-copergelenfatura', component: CoperGelenFatura, meta: { requiresAuth: true } },
{ path: '/fatura/ayarlar', name: 'faturaayarlar', component: FaturaAyarlar, meta: { requiresAuth: true }  },
{ path: '/fatura/tanimlamalar', name: 'faturatanimlamalar', component: FaturaTanimlamalarYeni, meta: { requiresAuth: true }  },
{ path: '/fatura/faturaxslt', name: 'faturaxslt', component: Faturaxslt, meta: { requiresAuth: true }  },
{ path: '/fatura/faturadizayntanimlama', name: 'faturadizayntanimlama', component: FaturadizaynTanimla, meta: { requiresAuth: true }  },
{ path: '/fatura/faturadizaynduzenle/:id' , name: 'faturadizaynduzenle', component: FaturadizaynDuzenle, meta: { requiresAuth: true }  },
{ path: '/fatura/faturadurumusorgula', name: 'faturasorgula', component:FaturaSorgula, meta: { requiresAuth: true }  },
{ path: '/fatura/gelenEFaturalariHavuzaKaydet', name: 'fatura-EFaturalariHavuzaKaydet', component:gelenEFaturalariHavuzaKaydet, meta: { requiresAuth: true }  },
{ path: '/fatura/gelenEFaturaListesi', name: 'fatura-EFaturaListesi', component:gelenEFaturaListesi, meta: { requiresAuth: true }  },
{ path: '/fatura/gelenEFaturaIsle/:id', name: 'fatura-EFaturaIsle', component:gelenEFaturaIsle, meta: { requiresAuth: true }  },
{ path: '/fatura/gelenEFaturaIsle/:id', name: 'fatura-EFaturaIsle', component:gelenEFaturaIsle, meta: { requiresAuth: true }  },

{ path: '/fatura/copertoplufatura', name: 'fatura-copertoplufaturalistesi', component:CoperTopluFatura, meta: { requiresAuth: true }  },
{ path: '/fatura/coperiade/:id', name: 'fatura-coperiade', component:CoperIade, meta: { requiresAuth: true }  },

{ path: '/fatura/copertoplufaturaislem', name: 'fatura-copertoplufaturaislem', component:CoperTopluFaturaIslem, meta: { requiresAuth: true }  },
{ path: '/fatura/aktarimlar/serbestfaturaexcel', name: 'fatura-aktarimlar-serbestfatura', component: SerbestFaturaAktarim, meta: { requiresAuth: true } },

{ path: '/urunler/ekurunler', name: 'ek-urunler', component: EkUrunler, meta: { requiresAuth: true }  },
{ path: '/test/test', name: 'test', component: TestJs, meta: { requiresAuth: false }  },
{ path: '/fatura/copersatisiade', name: 'fatura-coper-satisiade', component: CoperSatisIade, meta: { requiresAuth: true } },
{ path: '/fatura/copersatisiadeislem/:id', name: 'fatura-coper-satisiade-islem', component: CoperSatisIadeIslem, meta: { requiresAuth: true } },
{ path: '/fatura/faturaentegrasyon', name: 'faturaentegrasyon', component: FaturaListesiEntegrasyon, meta: { requiresAuth: false }  },

    //Coper Başla
    { path: '/coper/tanitimlar/exceladresaktarim', name: 'coper-tanitimlar-exceladresaktarim', component: exceladresaktarim, meta: { requiresAuth: true }},
    { path: '/coper/excelaktarim/index', name: 'coper-excel-aktarimi', component: ExcelSaticiAktarim, meta: { requiresAuth: true }},
    { path: '/coper/aktarim/bizitravel', name: 'coper-aktarim-bizitravel', component: coperbizitravelaktarim, meta: { requiresAuth: true }  },
    { path: '/coper/aktarim/arkmanotelrez', name: 'coper-aktarim-arkmanotelrez', component: coperarkmanotelrezaktarim, meta: { requiresAuth: true }  },
    
    { path: '/coper/aktarim/otelfirsati', name: 'coper-aktarim-otelfirsati', component: coperOtelFirsatiAktarim, meta: { requiresAuth: true } },
    { path: '/coper/aktarim/bookingagora', name: 'coper-aktarim-bookingagora', component: coperBookingAgoraAktarim, meta: { requiresAuth: true } },
    { path: '/coper/aktarim/juniper', name: 'coper-aktarim-juniper', component: coperJuniperAktarim, meta: { requiresAuth: true } },
    { path: '/coper/aktarim/bizitravelonline', name: 'coper-aktarim-bizitravelonline', component: coperbizitravelonlineaktarim, meta: { requiresAuth: true }  },
    { path: '/coper/otel/index', name: 'coper-otel-listesi', component: otelList, meta: { requiresAuth: true }  },
    { path: '/coper/transfer/index', name: 'coper-transfer-listesi', component: transferList, meta: { requiresAuth: true }  },
    { path: '/coper/restaurant/index', name: 'coper-restaurant-listesi', component: restaurantList, meta: { requiresAuth: true }  },
    { path: '/coper/acente/index', name: 'coper-acente-listesi', component: acenteList, meta: { requiresAuth: true }  },
    { path: '/coper/rehber/index', name: 'coper-rehber-listesi', component: rehberList, meta: { requiresAuth: true }  },
    { path: '/coper/gemi/index', name: 'coper-gemi-listesi', component: gemiList, meta: { requiresAuth: true }  },
    { path: '/coper/diger/index', name: 'coper-diger-listesi', component: digerList, meta: { requiresAuth: true }  },
    { path: '/coper/vize/index', name: 'coper-vize-listesi', component: vizeList, meta: { requiresAuth: true }  },
    { path: '/coper/vize/yeni/:id', name: 'coper-vize-yeni', component: vizeYeni, meta: { requiresAuth: true }  },
    { path: '/coper/turoperator/index', name: 'coper-turoperator-listesi', component: turoperatoruList, meta: { requiresAuth: true }  },
    { path: '/coper/sigorta/index', name: 'coper-sigorta-listesi', component: sigortaList, meta: { requiresAuth: true }  },
    { path: '/coper/feribot/index', name: 'coper-feribot-listesi', component: feribotList, meta: { requiresAuth: true }  },
    { path: '/coper/golf/index', name: 'coper-golf-listesi', component:golfList, meta: { requiresAuth: true }  },
    { path: '/coper/muze/index', name: 'coper-muze-listesi', component: muzeList, meta: { requiresAuth: true }  },
    { path: '/coper/rentacar/index', name: 'coper-rentacar-listesi', component: rentacarList, meta: { requiresAuth: true }  },
    { path: '/coper/charter/index', name: 'coper-charter-listesi', component: charterList, meta: { requiresAuth: true }  },
    { path: '/coper/saticilar/islem/:id', name: 'coper-saticilar-islem', component: SaticiIslem, meta: { requiresAuth: true } },
    { path: '/coper/saticilar/goster/:id', name: 'coper-saticilar-goster', component: SaticiGoster, meta: { requiresAuth: true }  },
    { path: '/coper/rezervasyonlistesi', name: 'coper-rezervasyonlistesi', component:coperrezervasyonListesi, meta: { requiresAuth: true }  },
    { path: '/coper/rezervasyon/rezervasyonlistesi', name: 'coper-rezervasyonlistesiGuncel', component:coperrezervasyonListesiGuncel, meta: { requiresAuth: true }  },
    { path: '/satis/ucus/liste', name: 'satis-ucus-liste', component:UcusListe, meta: { requiresAuth: true }  },

    
    

    { path: '/satis/ucus/islem/:id', name: 'satis-ucus-islem', component:UcusIslem, meta: { requiresAuth: true }  },
    { path: '/satis/ucus/rezervasyonliste', name: 'satis-ucus-rezliste', component:UcusRezListe, meta: { requiresAuth: true }  },
    { path: '/hotelrunner/oteltanitim/ekle', name: 'satis-hotelrunner-ekle', component:HotelRunnerEkle, meta: { requiresAuth: true }  },
    { path: '/hotelrunner/oteltanitim/list', name: 'satis-hotelrunner-list', component:HotelRunnerOtelList, meta: { requiresAuth: true }  },
    { path: '/hotelrunner/oteltanitim/update/:id', name: 'satis-hotelrunner-guncelle', component:HotelRunnerGuncelle, meta: { requiresAuth: true }  },
    { path: '/hotelrunner/index', name: 'satis-hotelrunner', component:HotelRunnerList, meta: { requiresAuth: true }  },
    { path: '/hotelrunner/otelislem/:id', name: 'satis-hotelrunner-otelislem', component: HotelRunnerOtelIslem, meta: { requiresAuth: true } },
    { path: '/hotelrunner/rezervasyon/:id', name: 'satis-hotelrunner-rezervasyon', component: HotelRunnerRezervasyon, meta: { requiresAuth: true } },
    { path: '/coper/paxdrive/index/:id', name: 'satis-paxdrive', component:PaxDriveList, meta: { requiresAuth: true }  },
    { path: '/coper/paxdrive/transferislem/:id', name: 'satis-paxdrive-transferislem', component: PaxDriveTransferIslem, meta: { requiresAuth: true } },
    { path: '/coper/paxdrive/transferliste', name: 'satis-paxdrive-transferliste', component:PaxDriveTransferList, meta: { requiresAuth: false }  },
    { path: '/coper/clinista/index', name: 'satis-clinista', component:Clinista, meta: { requiresAuth: true }  },
    { path: '/coper/clinista/clinistatakvim', name: 'satis-clinista-takvim', component:ClinistaTakvim, meta: { requiresAuth: true }  },
    { path: '/coper/clinista/acentetakvim/:id', name: 'satis-acente-takvim', component:ClinistaAcenteTakvim, meta: { requiresAuth: true }  },
    { path: '/coper/clinista/isteklistesi', name: 'satis-clinistaliste', component:ClinistaListe, meta: { requiresAuth: true }  },
    { path: '/coper/clinista/istekislem/:id', name: 'satis-clinistaislem', component:ClinistaIslem, meta: { requiresAuth: true }  },
    { path: '/coper/clinista/acenteisteklistesi', name: 'satis-clinistaacenteliste', component:ClinistaAcenteListe, meta: { requiresAuth: true }  },
    { path: '/coper/clinista/acenteistekislem/:id', name: 'satis-clinistaacenteistekislem', component:ClinistaAcenteIslem, meta: { requiresAuth: true }  },
    { path: '/takvim/takvim', name: 'takvim', component:Takvim, meta: { requiresAuth: true }  },
    { path: '/versiyonlar/index', name: 'versiyonlar-index', component:Versiyonlar, meta: { requiresAuth: true }  },

    { path: '/coper/tanitimlar/parametreler', name: 'coper-tanitimlar-parametrelist', component: CoperParametreList, meta: { requiresAuth: true }  },
    { path: '/coper/tanitimlar/parametretanitim/:id', name: 'coper-tanitimlar-parametre', component: ParametreTanitim, meta: { requiresAuth: true }  },
    { path: '/coper/tanitimlar/adreslistesi', name: 'coper-adreslistesi', component: coperAdresListesi, meta: { requiresAuth: true } },
    { path: '/coper/tanitimlar/otelkategori', name: 'coper-otelkategori', component: coperOtelKategori, meta: { requiresAuth: true } },
    { path: '/coper/tanitimlar/odeme', name: 'coper-odemelistesi', component: coperOdemeListesi, meta: { requiresAuth: true } },
    { path: '/coper/tanitimlar/adres/:id', name: 'coper-adres', component: coperAdres, meta: { requiresAuth: true } },
    { path: '/coper/tanitimlar/Otellistesi/otellistesi', name: 'coper-tanitimlar-otellistesi', component: coperOtelListesi, meta: { requiresAuth: true } },
    { path: '/coper/tanitimlar/Otellistesi/otelislem/:id', name: 'coper-tanitimlar-otelislem', component: coperOtelIslem, meta: { requiresAuth: true } },
    { path: '/coper/tanitimlar/acentekomisyon', name: 'coper-tanitimlar-acentekomisyon', component: coperAcenteKomisyon, meta: { requiresAuth: true } },
    { path: '/coper/tanitimlar/karlilik', name: 'coper-tanitimlar-karlilik', component: coperKarlilik, meta: { requiresAuth: true } },
    { path: '/coper/tanitimlar/vizefiyat/index', name: 'coper-tanitimlar-vizefiyatlist', component: coperVizeFiyat, meta: { requiresAuth: true } },
    { path: '/coper/tanitimlar/vizefiyat/islem/:id', name: 'coper-tanitimlar-vizefiyatislem', component: coperVizeFiyatIslem, meta: { requiresAuth: true } },

    
    { path: '/coper/mice/index/:id', name: 'mice-rezervasyon', component: MiceRezervasyon, meta: { requiresAuth: false } },
    { path: '/coper/rezervasyon/index/:id', name: 'coper-rezervasyon', component: CoperRezervasyon, meta: { requiresAuth: true } },
    { path: '/coper/page/formlar/voucher/:id', name: 'coper-voucher-form', component: VoucherForm, meta: { requiresAuth: true } },
    { path: '/coper/page/formlar/kotasyonformu/:id', name: 'coper-kotasyonformu', component: KotasyonFormu, meta: { requiresAuth: true } },
    { path: '/coper/page/formlar/gelenfaturalistesi', name: 'coper-gelenfaturalistesi', component: GelenFaturaListesiCoper, meta: { requiresAuth: true } },
    { path: '/coper/odemeler/saticiodemelistesi', name: 'coper-saticiodemeler', component: SaticiOdemeListesi, meta: { requiresAuth: true } },
    { path: '/coper/page/formlar/otelrezervasyonfisi/:id', name: 'coper-otelrezervasyonfisi-form', component: OtelRezervasyonForm, meta: { requiresAuth: true } },
    { path: '/coper/page/formlar/fatura/:id', name: 'coper-otelfatura-form', component: OtelFaturaForm, meta: { requiresAuth: true } },
    { path: '/coper/raporlar/satisraporu/', name: 'coper-satisraporu', component: CoperSatisRaporu, meta: { requiresAuth: true } },
    { path: '/diger/kesenkisirapor/', name: 'coper-kesenkisirapor', component: KesenKisiRapor, meta: { requiresAuth: false } },
    { path: '/coper/raporlar/genelamaclirapor/', name: 'coper-genelamaclirapor', component: CoperGenelAmacliRapor, meta: { requiresAuth: true } },
 { path: '/coper/raporlar/otelyolcumnerede', name: 'coper-yolcumnerede', component: CoperYolcumNerede, meta: { requiresAuth: false }  },
    { path: '/coper/raporlar/faturasigelengelmeyen/', name: 'coper-faturasigelengelmeyenraporu', component: CoperFaturasiGelenGelmeyen, meta: { requiresAuth: true } },

    { path: '/coper/raporlar/karlilikraporu/', name: 'coper-karlilikraporu', component: CoperKarlilikRaporu, meta: { requiresAuth: true } },
    { path: '/coper/raporlar/odemeraporu/', name: 'coper-odemeraporu', component: CoperOdemeRaporu, meta: { requiresAuth: true } },
    { path: '/coper/komisyonfaturasi/index/', name: 'coper-komisyonfaturasi', component: CoperKomisyonRaporu, meta: { requiresAuth: true } },
    { path: '/coper/komisyonfaturasi/faturaislem/', name: 'coper-komisyonfaturasiislem', component: CoperKomisyonFaturaIslem, meta: { requiresAuth: true } },
    { path: '/coper/saticitanit/:id/:saticiTipi', name: 'coper-saticitanit', component: saticitanit, meta: { requiresAuth: true }  },
    //{ path: '/coper/saticilist', name: 'saticilist', component: saticilist, meta: { requiresAuth: true }  },
    { path: '/coper/saticilar', name: 'coper-saticilar', component: saticilar, meta: { requiresAuth: true }  },
    { path: '/coper/saticilar/mapping', name: 'coper-arkmanmapping', component: arkmanmapping, meta: { requiresAuth: false }  },
    { path: '/coper/raporlar/gunlukturlistesi/', name: 'coper-gunluktur', component: GunlukTurListesi, meta: { requiresAuth: false }  },
    { path: '/coper/raporlar/transferisimlistesi/', name: 'coper-transferisimlistesi', component: TransferIsimListesi, meta: { requiresAuth: false }  },
    { path: '/coper/saticitumkayitlar/:saticiTipi', name: 'coper-saticitumkayitlar', component: saticitumkayitlar, meta: { requiresAuth: true }  },
    { path: '/coper/rezervasyon/:id', name: 'coper-rezervasyon', component: rezervasyon, meta: { requiresAuth: true }  },
    { path: '/coper/rezervasyonyeni', name: 'coper-rezervasyonyeni', component: rezervasyon, meta: { requiresAuth: true }  },
    { path: '/coper/coperSirket', name: 'coper-coperSirket', component: coperSirket, meta: { requiresAuth: true }  },
    { path: '/coper/parametreler', name: 'coper-parametreler', component: coperParametreler, meta: { requiresAuth: true }  },
    { path: '/coper/raporlar/vizetakiplistesi', name: 'coper-vizetakiplistesi', component: vizeTakipListesi, meta: { requiresAuth: true }  },
    { path: '/coper/tanitimlar/odatipleri', name: 'coper-tanitimlar-odatipleri', component: coperOdaTipleri, meta: { requiresAuth: true }  },
    { path: '/coper/tanitimlar/paketTurEkHizmet', name: 'coper-tanitimlar-paketEkHizmet', component: coperPaketTurEkHizmet, meta: { requiresAuth: true }  },
    { path: '/coper/tanitimlar/coperTurEtiket', name: 'coper-tanitimlar-coperTurEtiket', component: coperTurEtiket, meta: { requiresAuth: true }  },



    //Coper Bitiş
    //EFatura Başla
    { path: '/efatura/samplepage', name: 'samplepage', component: samplepage, meta: { requiresAuth: true }  },
    { path: '/efatura/efatura', name: 'efatura', component: efatura, meta: { requiresAuth: true }  },
    { path: '/efatura/mukellefsorgu', name: 'mukellefsorgu', component: mukellefsorgu, meta: { requiresAuth: true }  },
    { path: '/efatura/faturadurumusorgula', name: 'faturadurumusorgula', component: faturadurumusorgula, meta: { requiresAuth: true }  },


    //EFatura Bit

    //Muhasebe Başlangıç

    { path: '/muhasebe/parametreler/index', name: 'muhasebe-yardimcilar', component: muhasebeYardimcilar, meta: { requiresAuth: true,title:'Deneme' }  },
    { path: '/muhasebe/parametreler/index', name: 'muhasebe-parametreler', component: muhasebeParametreler, meta: { requiresAuth: true }  },
    { path: '/muhasebe/tanimlamalar/index', name: 'muhasebe-tanimlamalar', component: muhasebeTanimlamalar, meta: { requiresAuth: true }  },
    { path: '/muhasebe/tanimlamalar/sirkettanitim', name: 'muhasebe-tanimlamalar-sirkettanitim', component: muhasebeTanimlamalarSirketTanitim, meta: { requiresAuth: true }  },
    { path: '/muhasebe/tanimlamalar/merkeztanitim', name: 'muhasebe-tanimlamalar-merkeztanitim', component: muhasebeTanimlamalarMerkezTanitim, meta: { requiresAuth: true }  },
    { path: '/muhasebe/tanimlamalar/fistipitanitim', name: 'muhasebe-tanimlamalar-fistipitanitim', component: muhasebeTanimlamalarFisTipiTanitim, meta: { requiresAuth: true }  },
    { path: '/muhasebe/muhasebekodlari/index', name: 'muhasebe-muhasebekodlari-index', component: muhasebeKodlari, meta: { requiresAuth: true }  },
    { path: '/muhasebe/muhasebekodlari/islem/:id', name: 'muhasebe-muhasebekodlari-islem', component: muhasebeKodlariIslem, meta: { requiresAuth: true }  },
    { path: '/muhasebe/muhasebekodlari/liste', name: 'muhasebe-muhasebekodlari', component: muhasebeKodlariListe, meta: { requiresAuth: true }  },
    { path: '/muhasebe/muhasebekodlari/tevkifatbaglanti', name: 'muhasebe-tevkifat-baglanti', component: muhasebetevkifatbaglanti, meta: { requiresAuth: false }  },
    { path: '/muhasebe/fisler/liste', name: 'muhasebe-fisler-liste', component: muhasebeFislerListe, meta: { requiresAuth: true }  },
    { path: '/muhasebe/fisler/detay/:id', name: 'muhasebe-fisler-detay', component: muhasebeFislerDetay, meta: { requiresAuth: true }  },
    { path: '/muhasebe/fisler/islem/:id', name: 'muhasebe-fisler-islem', component: muhasebeFislerIslem, meta: { requiresAuth: true }  },
    { path: '/muhasebe/raporlar/hesabagore', name: 'muhasebe-rapor-hesap', component: muhasebeRaporHesap, meta: { requiresAuth: true }  },
    { path: '/muhasebe/raporlar/bilancorapor', name: 'muhasebe-rapor-bilancorapor', component: muhasebeRaporBilancoRapor, meta: { requiresAuth: true }  },
    { path: '/muhasebe/raporlar/bilancoformat', name: 'muhasebe-rapor-bilancoformat', component: muhasebeRaporBilancoFormat, meta: { requiresAuth: true }  },

     { path: '/muhasebe/raporlar/beyannamerapor', name: 'muhasebe-rapor-beyannamerapor', component: muhasebeRaporBeyannameRapor, meta: { requiresAuth: false }  },
    { path: '/muhasebe/raporlar/beyannameformat', name: 'muhasebe-rapor-beyannameformat', component: muhasebeRaporBeyannameFormat, meta: { requiresAuth: false }  },

    { path: '/muhasebe/raporlar/gelirgiderrapor', name: 'muhasebe-rapor-gelirgiderrapor', component: muhasebeRaporGelirGiderRapor, meta: { requiresAuth: true }  },
    { path: '/muhasebe/raporlar/gelirgiderformat', name: 'muhasebe-rapor-gelirgiderformat', component: muhasebeRaporGelirGiderFormat, meta: { requiresAuth: true }  },

    { path: '/muhasebe/raporlar/borcyaslandirma', name: 'muhasebe-rapor-borcyaslandirma', component: muhasebeBorcYaslandirma, meta: { requiresAuth: true }  },
    { path: '/muhasebe/raporlar/alacakyaslandirma', name: 'muhasebe-rapor-alacakyaslandirma', component: muhasebeAlacakYaslandirma, meta: { requiresAuth: true }  },
    { path: '/muhasebe/raporlar/referansagore', name: 'muhasebe-rapor-referans', component: muhasebeRaporReferans, meta: { requiresAuth: true }  },
    { path: '/muhasebe/raporlar/mizan', name: 'muhasebe-rapor-mizan', component: muhasebeRaporMizan, meta: { requiresAuth: true }  },
    { path: '/muhasebe/raporlar/referansmizan', name: 'muhasebe-referans-mizan', component: muhasebereferansMizan, meta: { requiresAuth: true }  },
    { path: '/muhasebe/raporlar/yekunkontrolu', name: 'muhasebe-rapor-yekunkontrolu', component: muhasebeRaporYekunKontrolu, meta: { requiresAuth: true }  },
    { path: '/muhasebe/resmidefter/defterolustur', name: 'muhasebe-resmidefter-defterolustur', component: muhasebeResmiDefterOlustur, meta: { requiresAuth: true }  },
    { path: '/muhasebe/resmidefter/deftersil', name: 'muhasebe-resmidefter-deftersil', component: muhasebeResmiDefterSil, meta: { requiresAuth: true }  },
    { path: '/muhasebe/resmidefter/mukerrerfiskontrol', name: 'muhasebe-resmidefter-mukerrerfiskontrol', component: mukerrerfiskontrol, meta: { requiresAuth: true }  },
    { path: '/muhasebe/resmidefter/schematronkontrol', name: 'muhasebe-resmidefter-schematronkontrol', component: schematronkontrol, meta: { requiresAuth: true }  },
    
    //Muhasebe Bitiş
    { path: '/task/task', name: 'task', component: task, meta: { requiresAuth: true }  },
    { path: '/test/deneme', name: 'testDeneme', component: testDeneme, meta: { requiresAuth: true }  },
    { path: '/muhasebe/edefter/edefterexport', name: 'muhasebe-edefter-edefterexport', component: edefterexport, meta: { requiresAuth: true }  },
    { path: '/muhasebe/parametreler/dinamikparametre', name: 'muhasebe-parametreler-dinamikparametre', component: dinamikparametre, meta: { requiresAuth: true }  },
    

    { path: '/diger/yardim', name: 'yardim', component: yardim, meta: { requiresAuth: true }  },
    { path: '/diger/videos', name: 'videos', component: videos, meta: { requiresAuth: true }  },
    { path: '/diger/kesenkisirapor', name: 'kesenkisirapor', component: kesenkisirapor, meta: {requiresAuth: true}},

    //Banka Entegrasyonu
    { path: '/bankaentegrasyonu/bankahareketleri', name: 'bankaentegrasyonu-online-banka-hareketleri', component: onlinebankahareketleri, meta: { requiresAuth: true }  },
    // yeni destek
    { path: '/destek/yardim', name: 'yardimv2', component: DestekYardim, meta: { requiresAuth: false }  },
    { path: '/destek/videos', name: 'videosv2', component: DestekVideos, meta: { requiresAuth: false }  },
  ]
})

// router.beforeEach((to, from, next) => {

//   // this.$refs.customdialog.open("tahsilat").then(sonuc => {
//   //   if (sonuc == true) {}
//   //   });


//   if (to.matched.length === 0) { // route yok
//     next({
//       path: '/'
//     })
//   } else {

//     var yetki = helpers.pageScreenAuth(to.name)

//     if (to.matched.some(record => record.meta.requiresAuth)) {
//       if (!auth.checkAuth()) {
//         next({
//           path: '/login',
//           query: {
//             redirect: to.fullPath
//           }
//         })
//       } else {
//         if (yetki == true) {
//           next()
//         } else {
//           window.alert('bu sayfaya yetkiniz yok')
//         }
//       }
//     } else {
//       if (yetki == true) {
//         next()
//       } else {
//         window.alert('bu sayfaya yetkiniz yok')
//       }
//     }

//     //  next()
//   }
// })

router.beforeEach((to, from, next) => {
var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    if (to.matched.length === 0) { // route yok
      next({
        path: '/'

      })
    } else {
      if (to.matched.some(record => record.meta.requiresAuth)) {

        if (!auth.checkAuth()) {

          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        } else {

          next()

          if ( to.name!='login' &&
          to.name!='register'  &&
          to.name!='anasirket'  &&
          to.name!='login-uye'  &&
          to.name!='urunsatis'  &&
          to.name!='uye-detay'  &&
          to.name!='uye-yeni'  &&
          to.name!='login-yetkigrup'  &&
          to.name!='login-yetkigruplist' &&
          to.name!='confirm'  &&
          to.name!='basarili' &&
          to.name!='hataodeme'  &&
          to.name!='urunsatinal'){
            var response = JSON.parse(window.localStorage.getItem('response'));

           if (credentials==null && response.UserTip != 3) {
            //if (credentials==null) {
            next({
              path: '/anasirket',
              query: { redirect: to.fullPath }
            })
                window.alert('Şirket seçimi yapmadan işleminize devam edemezsiniz...')
          } else {
           //if(response.UserId === 45){
            //next({
            //  path: '/coper/clinista/isteklistesi',
           // })
            //  window.location.href = "https://next.arkman.com.tr/#/coper/otel/index"
           //}
          }
        } else {
        }
        }

      } else {
        next()
      }
    //  console.log(to)
    //  document.title = to.meta.title;
    next()
    }



  })

router.afterEach(function (val) {

  var routem=[]

  routem= val.fullPath.split('/')

  if (!auth.checkAuth()) {

  window.localStorage.removeItem('token')
  window.localStorage.removeItem('credentials')

  if (routem[1]=='confirm' ) {


  } else {


   router.push({
     path: '/login'
   })

  }
  }
})





export default router

// export default {
//   router,
//   data: () => ({

//   }),

//   beforeMount: beforeMount,
// components: {
// customdialog}
// }